import GetListBanner from './GetListBanner'

export default GetListBanner
